import { navigate } from '../core/router';
import { tabIcons } from '../ui/icons';
import { setPageTitle } from '../users/users-shared';
import { t } from '../ui/lang';
import { can } from '../core/access';
import { renderOperationsTab } from './operations-tab';
import { renderDevicesTab } from './devices-tab';
// ── Tabbed Dashboards page ──────────────────────────────────────────────────────
//
// The team's cross-farm reporting section. Its first (and currently only) tab is the
// team-wide operations registry; further dashboards get their own tab + file here rather
// than growing this container.
//
// Tabs are ANCHORED like the Users page's: each has its own hash (`#!/dashboards`,
// `#!/dashboards/<tab>`) and switching one goes through the router, so a refresh, a
// shared link and the back button all land on the tab the user was actually on.
export function renderDashboards(tab = 'operations') {
    setPageTitle(t('dashboards.title'));
    const content = document.getElementById('content');
    const allowed = (k) => k === 'devices' ? can('page.dashboards.devices') : true;
    const active = allowed(tab) ? tab : 'operations';
    const tabBtn = (key, icon, label) => `<button class="settings-tab${key === active ? ' active' : ''}" data-tab="${key}">${icon}${label}</button>`;
    content.innerHTML = `
        <div class="settings-tabs" role="tablist">
            ${tabBtn('operations', tabIcons.operations, t('dashboards.tab_operations'))}
            ${can('page.dashboards.devices') ? tabBtn('devices', tabIcons.devices, t('dashboards.tab_devices')) : ''}
        </div>
        <div class="settings-panel settings-panel--wide dashboards-panel" data-panel="${active}"></div>
    `;
    content.querySelectorAll('.settings-tab').forEach((btn) => {
        btn.addEventListener('click', () => navigate({ page: 'dashboards', tab: btn.dataset['tab'] }));
    });
    const body = content.querySelector(`[data-panel="${active}"]`);
    if (active === 'devices')
        renderDevicesTab(body);
    else
        renderOperationsTab(body);
}
